export default {
  dailytech: {
    canCarteraClientes: 'pharmasan.dashboard.operacion.indicadores-operacion.card-cartera-clientes',
    canCarteraProveedores: 'pharmasan.dashboard.operacion.indicadores-operacion.card-cartera-proveedores',
    canIndicadoresFinancieros: 'pharmasan.dashboard.operacion.indicadores-financieros.indicadores',
    canRecaudos: 'pharmasan.dashboard.operacion.indicadores-operacion.recaudos'
  }
}
